import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Bank Rates List")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = { class: "indicator-label" }
const _hoisted_7 = { class: "indicator-progress" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = { class: "card-body pt-0" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'banks-rates'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
                type: "submit",
                id: "kt_account_profile_details_submit",
                ref: "submitButton",
                class: "btn btn-light-primary me-3"
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.translate('importBankRate')), 1),
                _createElementVNode("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_8
                ])
              ], 512),
              _createElementVNode("input", {
                type: "file",
                class: "d-none",
                ref: "fileInput",
                accept: ".xlsx, .xls, .csv",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadBankRateFile && _ctx.uploadBankRateFile(...args))),
                name: "fileInput",
                autocomplete: "off",
                id: "upload-files"
              }, null, 544),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('bank-rates-creating')))
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewBankRate')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-notClientPercentage": _withCtx(({ row: bank }) => [
              _createTextVNode(_toDisplayString(bank.notClientPercentage), 1)
            ]),
            "cell-percentage": _withCtx(({ row: bank }) => [
              _createTextVNode(_toDisplayString(bank.percentage), 1)
            ]),
            "cell-repaymentPeriod": _withCtx(({ row: bank }) => [
              _createTextVNode(_toDisplayString(bank.repaymentPeriod), 1)
            ]),
            "cell-isActive": _withCtx(({ row: bank }) => [
              (bank.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: bank }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editBank(bank.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_13),
              (bank.isMin || bank.isMax)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusBank(bank)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}